










































import { Component, Prop, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { SearchOptions, SearchProductOptions, SearchResult } from '@/models'
import { CV_VALUE_TYPE_PROD } from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'

@Component
export default class ProductsTable extends Vue {
  @Prop({ required: false, type: String }) readonly projectCode: string
  @Prop({ required: false, type: String }) readonly editorialProject: string

  private products: SearchResult = { items: [], pageOffset: 0, pageSize: 0, totalResults: 0 }
  private fieldsTableProducts: { key: string; label?: string; sortable?: boolean }[] = [
    { key: 'code', label: `${this.$t('project_view.products.table.header.id')}` },
    { key: 'name', label: `${this.$t('project_view.products.table.header.name')}` },
    { key: 'type', label: `${this.$t('project_view.products.table.header.type')}` }
  ]

  private defaultPageSize = 10
  private currentPage = 1
  private isBusy = false

  created() {
    CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD) // Load product cv values
  }

  private async loadProducts() {
    this.isBusy = true
    try {
      if (this.projectCode) {
        const searchOptions: SearchOptions = {
          search: '',
          offset: (this.currentPage - 1) * this.defaultPageSize,
          limit: this.defaultPageSize
        }
        const response = await ApiClient.getProjectProducts(this.projectCode, searchOptions)
        this.products = Object.assign({}, this.products, response)
        this.isBusy = false
        return response.items
      } else if (this.editorialProject) {
        const searchOptions: SearchProductOptions = {
          search: '',
          offset: (this.currentPage - 1) * this.defaultPageSize,
          limit: this.defaultPageSize,
          educationLevel1: null,
          manager: null,
          type: null,
          country: null,
          workType: null,
          subject: null,
          productionCampaign: null,
          editorialProject: this.editorialProject,
          relatedToDigital: null,
          editorialProjectYearStart: null,
          language: null,
          educationLevel2: null
        }

        const response = await ApiClient.searchProducts(searchOptions)
        this.products = Object.assign({}, this.products, response)
        if (response.totalResults < response.pageOffset) {
          this.currentPage = 1
          this.loadProducts()
        }
        this.isBusy = false
        return response.items
      }
    } catch (error) {
      this.isBusy = false
      return []
    }
  }

  private getCvValueName(codeId: string) {
    return CvValueUtils.getCvValueName(codeId, CV_VALUE_TYPE_PROD)
  }
}
